import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';

import Helmet from '../components/common/Helmet';

function NotFound() {
  return (
    <>
      <Helmet
        titleTranslationKey="404.meta.title"
        descriptionTranslationKey="404.meta.description"
      />
      <div
        className="d-flex flex-column justify-content-center text-center"
        style={{ height: '50vh' }}
      >
        <h1 className="display-4 text-muted">
          <span className="text-warning">404</span> - Out of bounds
        </h1>
        <p className="lead text-muted">
          <Translate id="404.Text" />
        </p>
      </div>
    </>
  );
}

export default withLocalize(NotFound);
